import availableContainingFeatures from './availableContainingFeatures.js';
import availableFeatureClasses from './availableFeatureClasses.js';
import CharacteristicCollection from './CharacteristicCollection.js';
import CharacteristicFeatureCollection from './CharacteristicFeatureCollection.js';
import ContainingFeatureQuery from './ContainingFeatureQuery.js';
import ContainingFeatureMetadata from './ContainingFeatureMetadata.js';
import ContainsCollectionQuery from './ContainsCollectionQuery.js';
import ContainsMetadataQuery from './ContainsMetadataQuery.js';
import DataReferenceCollectionResource from './DataReferenceCollectionResource.js';
import DataReferenceResource from './DataReferenceResource.js';
import FeatureAvailabilityQuery from './FeatureAvailabilityQuery.js';
import FeatureCollection from './FeatureCollection.js';
import FeatureContainsMetadata from './FeatureContainsMetadata.js';
import StatisticsRequest from './StatisticsRequest.js';
import UserLayerProxy from './UserLayerProxy.js';
function configure({ domain, protocol }) {
    const prefix = `${protocol}://${domain}`;
    CharacteristicCollection.$AR.url = `${prefix}/api/geodata/characteristic-collection`;
    CharacteristicFeatureCollection.$AR.url = `${prefix}/api/geodata/characteristic-feature-collection`;
    ContainingFeatureQuery.$AR.url = `${prefix}/api/geodata/containing-feature-query`;
    ContainsCollectionQuery.$AR.url = `${prefix}/api/geodata/contains-collection-query`;
    ContainsMetadataQuery.$AR.url = `${prefix}/api/geodata/contains-metadata-query`;
    DataReferenceCollectionResource.$AR.url = `${prefix}/api/geodata/data-reference-collection`;
    DataReferenceResource.$AR.url = `${prefix}/api/geodata/data-references`;
    FeatureAvailabilityQuery.$AR.url = `${prefix}/api/geodata/risym-feature-availability-query`;
    FeatureCollection.$AR.url = `${prefix}/api/geodata/feature-collection`;
    StatisticsRequest.$AR.url = `${prefix}/geodata/statistics-request`;
    UserLayerProxy.$AR.url = `${prefix}/api/geodata/user-layer-proxy`;
}
const geodata = {
    configure,
    availableContainingFeatures,
    availableFeatureClasses,
    CharacteristicCollection,
    CharacteristicFeatureCollection,
    ContainingFeatureQuery,
    ContainingFeatureMetadata,
    ContainsCollectionQuery,
    ContainsMetadataQuery,
    DataReferenceCollectionResource,
    DataReferenceResource,
    FeatureAvailabilityQuery,
    FeatureCollection,
    FeatureContainsMetadata,
    StatisticsRequest,
    UserLayerProxy,
};
/**
 * @namespace geodata
 */
export { configure, availableContainingFeatures, availableFeatureClasses, CharacteristicCollection, CharacteristicFeatureCollection, ContainingFeatureQuery, ContainingFeatureMetadata, ContainsCollectionQuery, ContainsMetadataQuery, DataReferenceCollectionResource, DataReferenceResource, FeatureAvailabilityQuery, FeatureCollection, FeatureContainsMetadata, StatisticsRequest, UserLayerProxy, };
export default geodata;
